<div class="demooz_checkbox" 
    [class.inline]="this.inlineCheckbox"
    [class.label_end]="this.labelPlacement === 'end'"
    [class.checked]="(this.formGroupDirective.form.controls[this.formName] && this.formGroupDirective.form.controls[this.formName].value)"
    [class.disabled]="this.disabled"
    >
    <label>
        <div [innerHTML]="this.labelCheckbox"></div>
        <div class="demooz_checkbox_container">
            <div class="demooz_checkbox_checkmark"></div>
            <input type="checkbox" [value]="this.valueCheckbox" [name]="this.formName" [formControlName]="this.formName"/>
        </div>        
    </label>
</div>

@if(this.errorText !== '' 
    && this.formGroupDirective.form.controls[this.formName] 
    && this.formGroupDirective.form.controls[this.formName].touched 
    && this.formGroupDirective.form.controls[this.formName].errors){
    <div class="demooz_input_error">{{this.errorText}}</div>
}